import { SiteConfig } from '../types/portfolio';

type FooterProps = {
  siteConfig: SiteConfig;
};

function Footer({ siteConfig }: FooterProps) {
  return (
    <footer className="border-t border-white/10 py-8">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 text-sm text-slate-400 sm:px-6 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <p className="font-medium text-slate-200">
            {siteConfig.name} - {siteConfig.title}
          </p>
          <p className="mt-1">Premium portfolio focused on enterprise Java and modern full-stack delivery.</p>
        </div>
        <p>{siteConfig.location}</p>
      </div>
    </footer>
  );
}

export default Footer;
